<template>
  <div class="work-order-audit">
    <!-- 导航标题 -->
    <ml-tip :showHeader="false" content="工单质量审核" />

    <!-- 搜索区域 -->
    <ml-tip :showHeader="false" style="border: 0">
      <ml-form inline labelWidth="100px" :model="searchData" ref="searchDataRef">
        <!-- 关键词搜索 -->
        <ml-input
          prop="keyword"
          placeholder="请输入工单标题"
          label="关键词:"
          v-model="searchData.keyword"
          style="margin-bottom: 0"
        />

        <!-- 时间范围选择 -->
        <ml-date-picker
          prop="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="YYYY-MM-DD"
          label="时间范围:"
          v-model="searchData.dateRange"
          :style="{ marginBottom: 0 }"
        />

        <!-- 状态筛选 -->
        <ml-select
          prop="apprStatus"
          placeholder="请选择状态"
          :options="statusOptions"
          label="状态:"
          keyName="key"
          labelName="value"
          valueName="key"
          v-model="searchData.apprStatus"
          :style="{ marginBottom: 0 }"
        />

        <!-- 审核状态筛选 -->
        <ml-select
          prop="status"
          placeholder="请选择审核状态"
          :options="auditStatusOptions"
          label="审核:"
          keyName="key"
          labelName="value"
          valueName="key"
          v-model="searchData.status"
          :style="{ marginBottom: 0 }"
        />

        <!-- 搜索按钮 -->
        <ml-button
          :style="{ 'margin-top': '10px', marginBottom: 0 }"
          submitText="搜索"
          submitIcon="el-icon-search"
          cancelText="重置"
          cancelIcon="el-icon-refresh"
          cancelType="danger"
          @click-cancel="resetSearchData"
          @click-submit="searchFn"
        />
      </ml-form>
    </ml-tip>

    <!-- 数据表格 -->
    <ml-tip :showHeader="false" class="default-tip" style="margin-bottom: 0">
      <el-table :data="tabberData.data" style="width: 100%" :height="tabberHeight(360)">
        <el-table-column align="center" type="index" width="60">
          <template #default="scope">
            {{ (tabberData.page - 1) * tabberData.size + (scope.$index + 1) }}
          </template>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          align="center"
          label="工单标题"
          prop="title"
          min-width="120"
        >
          <template #default="scope">
            <span class="opt-btn" @click="openDetailDialog(scope.row)">
              {{ scope.row.title }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          align="center"
          label="所属项目名称"
          prop="projectName"
          min-width="100"
        />

        <el-table-column
          show-overflow-tooltip
          align="center"
          label="所属阿米巴"
          prop="companyName"
          min-width="100"
        />

        <el-table-column
          show-overflow-tooltip
          align="center"
          label="故障类型"
          prop="errorTypeName"
          min-width="80"
        />

        <el-table-column
          show-overflow-tooltip
          align="center"
          label="故障描述"
          prop="errorDesc"
          min-width="150"
        />

        <el-table-column
          show-overflow-tooltip
          align="center"
          label="完工工时"
          prop="hours"
          min-width="80"
        />

        <el-table-column
          show-overflow-tooltip
          align="center"
          label="审核意见"
          prop="apprDesc"
          min-width="120"
        />

        <el-table-column
          show-overflow-tooltip
          align="center"
          label="工单状态"
          prop="apprStatus"
          min-width="80"
        >
          <template #default="scope">
            <el-tag
              :type="getStatusTagType(scope.row.apprStatus)"
              v-if="getStatusText(scope.row.apprStatus)"
              size="small"
            >
              {{ getStatusText(scope.row.apprStatus) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          align="center"
          label="审核状态"
          prop="status"
          min-width="80"
        >
          <template #default="scope">
            <el-tag
              :type="getAuditStatusTagType(scope.row.status)"
              v-if="getAuditStatusText(scope.row.status)"
              size="small"
            >
              {{ getAuditStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" min-width="100">
          <template #default="scope">
            <el-button
              size="mini"
              v-if="scope.row.status !== '1'"
              type="primary"
              link
              @click="openAuditDialog(scope.row)"
            >
              审核
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <ml-pagination
        :total="tabberData.total"
        :page="tabberData.page"
        v-model="tabberData.page"
        :size="tabberData.size"
        @current-change="currentChange"
        @size-change="sizeChange"
      />
    </ml-tip>

    <!-- 审核弹窗 -->
    <audit-dialog
      ref="auditDialogRef"
      v-if="auditDialogVisible"
      :workOrderId="currentAuditId"
      @submit="handleAuditSubmit"
      @close="closeAuditDialog"
    />

    <!-- 详情弹窗 -->
    <detail-dialog
      ref="detailDialogRef"
      v-if="detailDialogVisible"
      :workOrderId="currentDetailId"
      @close="closeDetailDialog"
    />

    <demo-dialog v-if="demoDialogVisible" ref="demoDialogRef" />
  </div>
</template>

<script>
import { onMounted, reactive, ref, nextTick } from 'vue'
import { useStore } from 'vuex'
import { getTabberData, tabberHeight } from '@/utils'
import AuditDialog from './auditDialog.vue'
import DetailDialog from './detailDialog.vue'
import demoDialog from './demoDialog.vue'

export default {
  name: 'WorkOrderAudit',
  components: {
    demoDialog,
    AuditDialog,
    DetailDialog
  },
  setup() {
    const { dispatch } = useStore()

    // 获取当月第一天和今天的日期
    const getCurrentMonthRange = () => {
      const now = new Date()
      const year = now.getFullYear()
      const month = now.getMonth()
      const day = now.getDate()

      // 当月第一天
      const firstDayStr = `${year}-${String(month + 1).padStart(2, '0')}-01`

      // 今天
      const todayStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(
        2,
        '0'
      )}`

      return [firstDayStr, todayStr]
    }

    // 搜索条件
    const searchData = reactive({
      keyword: '',
      dateRange: getCurrentMonthRange(),
      status: '',
      auditStatus: ''
    })

    // 表格数据
    const tabberData = reactive({
      data: [],
      total: 0,
      page: 1,
      size: 10
    })

    // 状态选项
    const statusOptions = ref([
      { key: '', value: '全部' },
      { key: '0', value: '无效' },
      { key: '1', value: '有效' }
    ])

    // 审核状态选项
    const auditStatusOptions = ref([
      { key: '', value: '全部' },
      { key: '1', value: '已审核' },
      { key: '0', value: '未审核' }
    ])

    // 审核弹窗控制
    const auditDialogVisible = ref(false)
    const currentAuditId = ref('')
    const auditDialogRef = ref(null)

    // 详情弹窗控制
    const detailDialogVisible = ref(false)
    const currentDetailId = ref('')
    const detailDialogRef = ref(null)

    const demoDialogVisible = ref(false)
    const demoDialogRef = ref(null)

    // 获取列表数据
    const getTableData = async () => {
      // 处理时间范围
      let startTime = ''
      let endTime = ''
      if (searchData.dateRange && searchData.dateRange.length === 2) {
        startTime = searchData.dateRange[0]
        endTime = searchData.dateRange[1]
      }
      const params = {
        pageIndex: tabberData.page,
        pageSize: tabberData.size,
        startTime,
        endTime,
        apprStatus: searchData.apprStatus,
        status: searchData.status,
        keyword: searchData.keyword
      }
      const { data } = await getTabberData(dispatch, 'fetchGetWorkOrderAuditPage', params)
      tabberData.data = data?.records || []
      tabberData.total = data?.total || 0
      // 清理临时添加的字段
      delete searchData.startDate
      delete searchData.endDate
    }

    // 搜索
    const searchFn = () => {
      tabberData.page = 1
      getTableData()
    }

    // 重置搜索
    const resetSearchData = () => {
      searchData.keyword = ''
      searchData.dateRange = []
      searchData.status = ''
      searchData.apprStatus = ''
      searchFn()
    }

    // 打开审核弹窗
    const openAuditDialog = async row => {
      currentAuditId.value = row.errorId
      auditDialogVisible.value = true
      console.log('审核', currentAuditId.value, auditDialogVisible.value, auditDialogRef.value)
      // 等待 DOM 更新后调用子组件的 openDialog 方法
      await nextTick()
      auditDialogRef.value.dialogRef.showDialog = true
    }

    // 关闭审核弹窗
    const closeAuditDialog = () => {
      auditDialogVisible.value = false
      currentAuditId.value = ''
    }

    // 打开详情弹窗
    const openDetailDialog = async row => {
      currentDetailId.value = row.errorId
      detailDialogVisible.value = true
      // 等待 DOM 更新后打开弹窗
      await nextTick()
      detailDialogRef.value.dialogRef.showDialog = true
    }

    // 关闭详情弹窗
    const closeDetailDialog = () => {
      detailDialogVisible.value = false
      currentDetailId.value = ''
    }

    // 处理审核提交
    const handleAuditSubmit = async auditForm => {
      const params = {
        errorId: currentAuditId.value,
        ...auditForm
      }
      const { data } = await dispatch('fetchSubmitWorkOrderAudit', params)
      console.log('审核提交结果:', data)

      // 刷新表格
      getTableData()
      // 关闭弹窗
      closeAuditDialog()
      return data
    }

    // 分页变化
    const currentChange = val => {
      tabberData.page = val
      getTableData()
    }

    const sizeChange = val => {
      tabberData.size = val
      tabberData.page = 1
      getTableData()
    }

    // 获取状态文本
    const getStatusText = status => {
      const statusMap = {
        '-1': '待处理',
        0: '无效',
        1: '有效'
      }
      return statusMap[status] || status
    }

    // 获取状态标签类型
    const getStatusTagType = status => {
      const typeMap = {
        '-1': 'warning',
        0: 'info',
        1: 'success'
      }
      return typeMap[status] || ''
    }

    // 获取审核状态文本
    const getAuditStatusText = auditStatus => {
      const statusMap = {
        0: '未审核',
        1: '已审核'
      }
      return statusMap[auditStatus] || auditStatus
    }

    // 获取审核状态标签类型
    const getAuditStatusTagType = auditStatus => {
      const typeMap = {
        0: 'warning',
        1: 'success'
      }
      return typeMap[auditStatus] || ''
    }

    onMounted(() => {
      getTableData()
    })

    return {
      searchData,
      tabberData,
      statusOptions,
      auditStatusOptions,
      auditDialogVisible,
      currentAuditId,
      detailDialogVisible,
      currentDetailId,
      searchFn,
      resetSearchData,
      openAuditDialog,
      closeAuditDialog,
      openDetailDialog,
      closeDetailDialog,
      handleAuditSubmit,
      currentChange,
      sizeChange,
      getStatusText,
      getStatusTagType,
      getAuditStatusText,
      getAuditStatusTagType,
      tabberHeight,
      demoDialogRef,
      auditDialogRef,
      detailDialogRef,
      demoDialogVisible
    }
  }
}
</script>

<style scoped lang="scss">
.work-order-audit {
  padding: 20px;
}
.opt-btn {
  cursor: pointer;
  color: #409eff;
}
</style>
